module.exports = __webpack_public_path__ + "img/fuzhen.098b0fca.jpg";